import __request__ from "routing/request";
export function index() {
  return __request__("GET", "/system/indexer/overview", null, {}, {
    "Accept": ["application/json"]
  });
}
export function indexByindexSetId(indexSetId) {
  return __request__("GET", `/system/indexer/overview/${indexSetId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
